var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-main has-bottom" },
        [
          _c("page-title", {
            attrs: { back: true },
            on: { goback: _vm.goback },
          }),
          _vm._v(" "),
          _c(
            "page-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { "margin-bottom": "32px" },
            },
            [
              _c("template", { slot: "header" }, [
                _vm._v("\n        Producer Information\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("base-info", {
                    attrs: { "page-data": _vm.pageData },
                    on: {
                      "update:pageData": function ($event) {
                        _vm.pageData = $event
                      },
                      "update:page-data": function ($event) {
                        _vm.pageData = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-header" }, [
                    _vm._v("\n          Well Information\n        "),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.wellList, function (well, index) {
                    return _c("wellComp", {
                      key: "well" + index,
                      attrs: { "page-data": well, "well-index": index },
                    })
                  }),
                ],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _c(
              "div",
              { staticClass: "page-btns" },
              [
                _c("loading-btn", {
                  attrs: { label: "Reject" },
                  on: { clickHandle: _vm.toReject },
                }),
                _vm._v(" "),
                _c("loading-btn", {
                  attrs: { type: "primary", label: "Approval" },
                  on: { clickHandle: _vm.agree },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("editInformationSuccess", {
        ref: "editInformationSuccess",
        attrs: { "no-tip": true, msg: "Approved completed!" },
        on: { close: _vm.goback },
      }),
      _vm._v(" "),
      _c("rejectDialog", {
        ref: "rejectDialog",
        on: { success: _vm.reject, cancel: _vm.rejectCancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }